import Loading from 'components/Loading';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { getBadge } from 'services/badge.routes';
import queryString from "utils/queryString";
import BadgeTable from './BadgeTable';

export default function Badge() {
    const [loading, setLoading] = useState(false);
    const [badges, setBadges] = useState([]);

    useEffect(() => {
        setLoading(true);
        const query = {
            with_category: 1,
            with_icon: 1
        }
        getBadge(queryString(query), false, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message)
            } else {
                setLoading(false);
                setBadges(data);
            }
        })
    }, []);


    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <BadgeTable data={badges} />
        </DashboardLayout>
    )
}
